import { render, staticRenderFns } from "./TextBlockAndBulletList.vue?vue&type=template&id=c8e3164c&"
import script from "./TextBlockAndBulletList.vue?vue&type=script&lang=js&"
export * from "./TextBlockAndBulletList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports